export const _system_settings = [
  {
    id: 'models',
    active: true,
    item_name: '生成AIモデルの管理',
    description: '生成AIモデルの設定をします'
  },
  {
    id: 'submissionAnalysisPrompts',
    active: true,
    item_name: '提出分析プロンプトの設定',
    description: '提出チャットの分析プロンプトの設定をします'
  },
  {
    id: 'studentAnalysisPrompts',
    active: true,
    item_name: '生徒の会話分析プロンプトの設定',
    description: '提出チャットの分析プロンプトの設定をします'
  }
]

export const _gpt_model = [
  {
    displayName: '【推奨】Azure版GPT-4o',
    value: 'azure-gpt-4o',
    availableAssistApi: true,
    availableVision: true,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.01,
    outputCost: 0.001
  },
  {
    displayName: '【推奨】Azure版GPT-4o-mini',
    value: 'azure-gpt-4o-mini',
    availableAssistApi: true,
    availableVision: true,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【推奨】Azure版GPT-3.5_turbo',
    value: 'azure-gpt-3.5-turbo',
    availableAssistApi: false,
    availableVision: false,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.001,
    outputCost: 0.001
  },
  {
    displayName: '【推奨】Azure版GPT-4_turbo',
    value: 'azure-gpt-4-turbo',
    availableAssistApi: false,
    availableVision: false,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【一般提供版】OpenAI版GPT-4_turbo with vision',
    value: 'gpt-4-turbo-2024-04-09',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'openai',
    inputCost: 0.02,
    outputCost: 0.02
  },
  {
    displayName: '【試験運用版】OpenAI版GPT-4_turbo with vision',
    value: 'gpt-4-vision-preview',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'openai',
    inputCost: 0.02,
    outputCost: 0.02
  },
  {
    displayName: '【緊急用】OpenAI版GPT-3.5_turbo',
    value: 'gpt-3.5-turbo',
    availableAssistApi: true,
    availableVision: false,
    streaming: true,
    provider: 'openai',
    inputCost: 0.001,
    outputCost: 0.001
  },
  {
    displayName: '【緊急用】OpenAI版GPT-4_turbo',
    value: 'gpt-4-1106-preview',
    availableAssistApi: true,
    availableVision: false,
    streaming: true,
    provider: 'openai',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【緊急用】OpenAI版GPT-4o',
    value: 'gpt-4o',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'openai',
    inputCost: 0.01,
    outputCost: 0.001
  },
  {
    displayName: '【試験運用版】OpenAI版o1',
    value: 'o1-preview-2024-09-12',
    availableAssistApi: false,
    availableVision: false,
    streaming: false,
    provider: 'openai',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【試験運用版】Azure版o1',
    value: 'azure-o1',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【試験運用版】Claude-3_Haiku',
    value: 'claude-3-haiku-20240307',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'anthropic',
    inputCost: 0.001,
    outputCost: 0.001
  },
  {
    displayName: '【試験運用版】Claude-3_Sonnet',
    value: 'claude-3-sonnet-20240229',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'anthropic',
    inputCost: 0.005,
    outputCost: 0.005
  },
  {
    displayName: '【試験運用版】Claude-3_Opus',
    value: 'claude-3-opus-20240229',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'anthropic',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【試験運用版】Amazon版Claude-3.5_Sonnet',
    value: 'anthropic.claude-3-5-sonnet-20240620-v1:0',
    anthropic_version: 'bedrock-2023-05-31',
    availableAssistApi: false,
    availableVision: true,
    streaming: true,
    provider: 'amazon',
    inputCost: 0.01,
    outputCost: 0.01
  },
  {
    displayName: '【試験運用版】Azure版GPT-4o(フィルターlow)',
    value: 'azure-gpt-4o-contents-filter-low',
    availableAssistApi: true,
    availableVision: true,
    streaming: true,
    provider: 'microsoft',
    inputCost: 0.01,
    outputCost: 0.001
  }
]

// 削除予定
export const _gpt_input_cost = [
  { type: 'gpt-3.5-turbo', cost: 0.001 },
  { type: 'gpt-4', cost: 0.01 },
  { type: 'gpt-4-turbo', cost: 0.01 },
  { type: 'gpt-4-1106-preview', cost: 0.01 },
  { type: 'gpt-4o', cost: 0.01 },
  { type: 'azure-gpt-4-turbo', cost: 0.01 },
  { type: 'azure-gpt-3.5-turbo', cost: 0.001 },
  { type: 'azure-gpt-4-vision', cost: 0.02 },
  { type: 'gpt-4-vision-preview', cost: 0.02 },
  { type: 'gpt-4-turbo-2024-04-09', cost: 0.02 },
  { type: 'gpt-4-0125-preview', cost: 0.01 },
  { type: 'gpt-3.5-turbo-0125', cost: 0.001 },
  { type: 'claude-3-haiku-20240307', cost: 0.001 },
  { type: 'claude-3-sonnet-20240229', cost: 0.005 },
  { type: 'claude-3-opus-20240229', cost: 0.01 },
  { type: 'azure-gpt-4o', cost: 0.01 },
  { type: 'azure-gpt-4o-mini', cost: 0.01 },
  { type: 'o1-preview-2024-09-12', cost: 0.01 },
  { type: 'anthropic.claude-3-5-sonnet-20240620-v1:0', cost: 0.01 },
  { type: 'azure-gpt-4o-contents-filter-low', cost: 0.01 }
]

// 削除予定
export const _gpt_output_cost = [
  { type: 'gpt-3.5-turbo', cost: 0.001 },
  { type: 'gpt-4', cost: 0.01 },
  { type: 'gpt-4-turbo', cost: 0.01 },
  { type: 'gpt-4o', cost: 0.01 },
  { type: 'azure-gpt-4-turbo', cost: 0.01 },
  { type: 'azure-gpt-3.5-turbo', cost: 0.001 },
  { type: 'azure-gpt-4-vision', cost: 0.02 },
  { type: 'gpt-4-vision-preview', cost: 0.02 },
  { type: 'gpt-4-turbo-2024-04-09', cost: 0.02 },
  { type: 'gpt-4-0125-preview', cost: 0.01 },
  { type: 'gpt-3.5-turbo-0125', cost: 0.001 },
  { type: 'claude-3-haiku-20240307', cost: 0.001 },
  { type: 'claude-3-sonnet-20240229', cost: 0.005 },
  { type: 'claude-3-opus-20240229', cost: 0.01 },
  { type: 'azure-gpt-4o', cost: 0.01 },
  { type: 'azure-gpt-4o-mini', cost: 0.01 },
  { type: 'o1-preview-2024-09-12', cost: 0.01 },
  { type: 'anthropic.claude-3-5-sonnet-20240620-v1:0', cost: 0.01 },
  { type: 'azure-gpt-4o-contents-filter-low', cost: 0.01 }
]

// 先生専用ページ
export const _tutor_pages = [
  '/management',
  '/chat_data',
  '/thread_list',
  '/ui_setting',
  '/submission_management',
  '/submitted_conversations'
]
// ログインページ
export const _field_name_of_admin_management = {
  item_name: '名前',
  item_id: 'ID',
  item_description: '説明',
  item_updated_at: '更新日',
  item_active: 'アクティブ'
}

export const _login_pages = ['/login', '/login_for_student', '/login_for_mingaku_tutor', '/signup_for_mingaku_tutor']

export const _grade = [
  '小学1年生',
  '小学2年生',
  '小学3年生',
  '小学4年生',
  '小学5年生',
  '小学6年生',
  '中学1年生',
  '中学2年生',
  '中学3年生',
  '高校1年生',
  '高校2年生',
  '高校3年生',
  'その他'
]
export const _fields_of_user_data_in_mypage = [
  {
    displayName: '名前',
    value: 'name',
    type: 'all',
    editingPermission: false,
    source: 'mingaku',
    textareaRows: 1
  },
  {
    displayName: '生徒ID',
    value: 'studentId',
    type: 'student',
    editingPermission: false,
    source: 'mingaku',
    textareaRows: 1
  },
  {
    displayName: '学年',
    value: 'grade',
    type: 'student',
    editingPermission: false,
    source: 'mingaku',
    textareaRows: 1
  },
  {
    displayName: 'スクール',
    value: 'schoolName',
    type: 'tutor',
    editingPermission: false,
    source: 'mingaku',
    textareaRows: 1
  },
  {
    displayName: 'メールアドレス',
    value: 'email',
    type: 'tutor',
    editingPermission: false,
    source: 'mingaku',
    textareaRows: 1
  },
  {
    displayName: '自由記入欄',
    value: 'freeInput',
    type: 'student',
    editingPermission: true,
    source: 'schoolAi',
    textareaRows: 2
  },
  {
    displayName: '特徴',
    value: 'characteristic',
    type: 'student',
    editingPermission: true,
    source: 'mingaku',
    mypage: false,
    textareaRows: 2
  }
]

export const _number_of_data = [10]
// フォーム設定プルダウンテンプレート
export const _pulldownTemplates = [
  {
    name: 'なし',
    key: 'default',
    selectOptions: [{ order: 1, displayName: '', value: '' }]
  },
  {
    name: '学年（小学生）',
    key: 'elementary_school_grades',
    selectOptions: [
      { order: 1, displayName: '小1', value: '小1' },
      { order: 2, displayName: '小2', value: '小2' },
      { order: 3, displayName: '小3', value: '小3' },
      { order: 4, displayName: '小4', value: '小4' },
      { order: 5, displayName: '小5', value: '小5' },
      { order: 6, displayName: '小6', value: '小6' }
    ]
  },
  {
    name: '学年（中学生）',
    key: 'junior_high_school_grades',
    selectOptions: [
      { order: 1, displayName: '中1', value: '中1' },
      { order: 2, displayName: '中2', value: '中2' },
      { order: 3, displayName: '中3', value: '中3' }
    ]
  },
  {
    name: '学年（高校生）',
    key: 'high_school_grades',
    selectOptions: [
      { order: 1, displayName: '高1', value: '高1' },
      { order: 2, displayName: '高2', value: '高2' },
      { order: 3, displayName: '高3', value: '高3' },
      { order: 4, displayName: 'その他', value: 'その他' }
    ]
  },
  {
    name: '学年（全学年）',
    key: 'grades',
    selectOptions: [
      { order: 1, displayName: '小学1年生', value: '小学1年生' },
      { order: 2, displayName: '小学2年生', value: '小学2年生' },
      { order: 3, displayName: '小学3年生', value: '小学3年生' },
      { order: 4, displayName: '小学4年生', value: '小学4年生' },
      { order: 5, displayName: '小学5年生', value: '小学5年生' },
      { order: 6, displayName: '小学6年生', value: '小学6年生' },
      { order: 7, displayName: '中学1年生', value: '中学1年生' },
      { order: 8, displayName: '中学2年生', value: '中学2年生' },
      { order: 9, displayName: '中学3年生', value: '中学3年生' },
      { order: 10, displayName: '高校1年生', value: '高校1年生' },
      { order: 11, displayName: '高校2年生', value: '高校2年生' },
      { order: 12, displayName: '高校3年生', value: '高校3年生' }
    ]
  },
  {
    name: '時間割',
    key: 'timetable',
    selectOptions: [
      { order: 1, displayName: '0時間目', value: '0時間目' },
      { order: 2, displayName: '1時間目', value: '1時間目' },
      { order: 3, displayName: '2時間目', value: '2時間目' },
      { order: 4, displayName: '3時間目', value: '3時間目' },
      { order: 5, displayName: '4時間目', value: '4時間目' },
      { order: 6, displayName: '5時間目', value: '5時間目' },
      { order: 7, displayName: '6時間目', value: '6時間目' },
      { order: 8, displayName: '7時間目', value: '7時間目' },
      { order: 9, displayName: '8時間目', value: '8時間目' },
      { order: 10, displayName: '9時間目', value: '9時間目' },
      { order: 11, displayName: '10時間目', value: '10時間目' }
    ]
  },
  {
    name: '受験タイプ',
    key: 'exam_type',
    selectOptions: [
      { order: 1, displayName: '小学受験', value: '小学受験' },
      { order: 2, displayName: '中学受験', value: '中学受験' },
      { order: 3, displayName: '高校受験', value: '高校受験' },
      { order: 4, displayName: '大学受験', value: '大学受験' },
      { order: 5, displayName: '資格試験', value: '資格試験' },
      { order: 6, displayName: 'その他試験', value: 'その他試験' }
    ]
  },
  {
    name: '問題形式',
    key: 'question_format',
    selectOptions: [
      { order: 1, displayName: '4択', value: '4択' },
      { order: 2, displayName: '穴埋め', value: '穴埋め' },
      { order: 3, displayName: '記述', value: '記述' },
      { order: 4, displayName: '空欄補充', value: '空欄補充' },
      { order: 5, displayName: '論述', value: '論述' }
    ]
  },
  {
    name: '教科（小学校）',
    key: 'subject_elementary_school',
    selectOptions: [
      { order: 1, displayName: '国語', value: '国語' },
      { order: 2, displayName: '算数', value: '算数' },
      { order: 3, displayName: '理科', value: '理科' },
      { order: 4, displayName: '社会', value: '社会' },
      { order: 5, displayName: '生活', value: '生活' },
      { order: 6, displayName: '英語', value: '英語' },
      { order: 7, displayName: '音楽', value: '音楽' },
      { order: 8, displayName: '美術', value: '美術' },
      { order: 9, displayName: '保険体育', value: '保険体育' },
      { order: 10, displayName: '技術家庭', value: '技術家庭' },
      { order: 11, displayName: '総合', value: '総合' }
    ]
  },
  {
    name: '教科（中学校）',
    key: 'subject_junior_high_school',
    selectOptions: [
      { order: 1, displayName: '英語', value: '英語' },
      { order: 2, displayName: '数学', value: '数学' },
      { order: 3, displayName: '国語', value: '国語' },
      { order: 4, displayName: '理科', value: '理科' },
      { order: 5, displayName: '社会', value: '社会' },
      { order: 6, displayName: '音楽', value: '音楽' },
      { order: 7, displayName: '美術', value: '美術' },
      { order: 8, displayName: '保険体育', value: '保険体育' },
      { order: 9, displayName: '技術家庭', value: '技術家庭' },
      { order: 10, displayName: '総合', value: '総合' }
    ]
  },
  {
    name: '教科（高校）',
    key: 'subject_high_school',
    selectOptions: [
      { order: 1, displayName: '英語', value: '英語' },
      { order: 2, displayName: '数学', value: '数学' },
      { order: 3, displayName: '国語', value: '国語' },
      { order: 4, displayName: '理科', value: '理科' },
      { order: 5, displayName: '地理歴史・公民', value: '地理歴史・公民' },
      { order: 6, displayName: '音楽', value: '音楽' },
      { order: 7, displayName: '美術', value: '美術' },
      { order: 8, displayName: '保険体育', value: '保険体育' },
      { order: 9, displayName: '技術家庭', value: '技術家庭' },
      { order: 10, displayName: '情報', value: '情報' },
      { order: 11, displayName: '総合', value: '総合' }
    ]
  },
  {
    name: '漢字配当表（該当学年の漢字のみ）',
    key: 'kanji_grade',
    selectOptions: [
      {
        order: 1,
        displayName: '1年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六'
      },
      {
        order: 2,
        displayName: '2年生',
        value:
          '引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話'
      },
      {
        order: 3,
        displayName: '3年生',
        value:
          '悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和'
      },
      {
        order: 4,
        displayName: '4年生',
        value:
          '愛案以衣位囲胃印英栄塩億加果貨課芽改械害街各覚完官管関観願希季紀喜旗器機議求泣救給挙漁共協鏡競極訓軍郡径型景芸欠結建健験固功好候航康告差菜最材昨札刷殺察参産散残士氏史司試児治辞失借種周祝順初松笑唱焼象照賞臣信成省清静席積折節説浅戦選然争倉巣束側続卒孫帯隊達単置仲貯兆腸低底停的典伝徒努灯堂働特得毒熱念敗梅博飯飛費必票標不夫付府副粉兵別辺変便包法望牧末満未脈民無約勇要養浴利陸良料量輪類令冷例歴連老労録'
      },
      {
        order: 5,
        displayName: '5年生',
        value:
          '圧移因永営衛易益液演応往桜恩可仮価河過賀快解格確額刊幹慣眼基寄規技義逆久旧居許境均禁句群経潔件券険検限現減故個護効厚耕鉱構興講混査再災妻採際在財罪雑酸賛支志枝師資飼示似識質舎謝授修述術準序招承証条状常情織職制性政勢精製税責績接設舌絶銭祖素総造像増則測属率損退貸態団断築張提程適敵統銅導徳独任燃能破犯判版比肥非備俵評貧布婦富武復複仏編弁保墓報豊防貿暴務夢迷綿輸余預容略留領'
      },
      {
        order: 6,
        displayName: '6年生',
        value:
          '異遺域宇映延沿我灰拡革閣割株干巻看簡危机揮貴疑吸供胸郷勤筋系敬警劇激穴絹権憲源厳己呼誤后孝皇紅降鋼刻穀骨困砂座済裁策冊蚕至私姿視詞誌磁射捨尺若樹収宗就衆従縦縮熟純処署諸除将傷障城蒸針仁垂推寸盛聖誠宣専泉洗染善奏窓創装層操蔵臓存尊宅担探誕段暖値宙忠著庁頂潮賃痛展討党糖届難乳認納脳派拝背肺俳班晩否批秘腹奮並陛閉片補暮宝訪亡忘棒枚幕密盟模訳郵優幼欲翌乱卵覧裏律臨朗論'
      }
    ]
  },
  {
    name: '漢字配当表（該当学年終了までに習得済みの全漢字）',
    key: 'kanji_grade_all',
    selectOptions: [
      {
        order: 1,
        displayName: '1年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六'
      },
      {
        order: 2,
        displayName: '2年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話'
      },
      {
        order: 3,
        displayName: '3年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和'
      },
      {
        order: 4,
        displayName: '4年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和愛案以衣位囲胃印英栄塩億加果貨課芽改械害街各覚完官管関観願希季紀喜旗器機議求泣救給挙漁共協鏡競極訓軍郡径型景芸欠結建健験固功好候航康告差菜最材昨札刷殺察参産散残士氏史司試児治辞失借種周祝順初松笑唱焼象照賞臣信成省清静席積折節説浅戦選然争倉巣束側続卒孫帯隊達単置仲貯兆腸低底停的典伝徒努灯堂働特得毒熱念敗梅博飯飛費必票標不夫付府副粉兵別辺変便包法望牧末満未脈民無約勇要養浴利陸良料量輪類令冷例歴連老労録'
      },
      {
        order: 5,
        displayName: '5年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和愛案以衣位囲胃印英栄塩億加果貨課芽改械害街各覚完官管関観願希季紀喜旗器機議求泣救給挙漁共協鏡競極訓軍郡径型景芸欠結建健験固功好候航康告差菜最材昨札刷殺察参産散残士氏史司試児治辞失借種周祝順初松笑唱焼象照賞臣信成省清静席積折節説浅戦選然争倉巣束側続卒孫帯隊達単置仲貯兆腸低底停的典伝徒努灯堂働特得毒熱念敗梅博飯飛費必票標不夫付府副粉兵別辺変便包法望牧末満未脈民無約勇要養浴利陸良料量輪類令冷例歴連老労録圧移因永営衛易益液演応往桜恩可仮価河過賀快解格確額刊幹慣眼基寄規技義逆久旧居許境均禁句群経潔件券険検限現減故個護効厚耕鉱構興講混査再災妻採際在財罪雑酸賛支志枝師資飼示似識質舎謝授修述術準序招承証条状常情織職制性政勢精製税責績接設舌絶銭祖素総造像増則測属率損退貸態団断築張提程適敵統銅導徳独任燃能破犯判版比肥非備俵評貧布婦富武復複仏編弁保墓報豊防貿暴務夢迷綿輸余預容略留領'
      },
      {
        order: 6,
        displayName: '6年生',
        value:
          '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和愛案以衣位囲胃印英栄塩億加果貨課芽改械害街各覚完官管関観願希季紀喜旗器機議求泣救給挙漁共協鏡競極訓軍郡径型景芸欠結建健験固功好候航康告差菜最材昨札刷殺察参産散残士氏史司試児治辞失借種周祝順初松笑唱焼象照賞臣信成省清静席積折節説浅戦選然争倉巣束側続卒孫帯隊達単置仲貯兆腸低底停的典伝徒努灯堂働特得毒熱念敗梅博飯飛費必票標不夫付府副粉兵別辺変便包法望牧末満未脈民無約勇要養浴利陸良料量輪類令冷例歴連老労録圧移因永営衛易益液演応往桜恩可仮価河過賀快解格確額刊幹慣眼基寄規技義逆久旧居許境均禁句群経潔件券険検限現減故個護効厚耕鉱構興講混査再災妻採際在財罪雑酸賛支志枝師資飼示似識質舎謝授修述術準序招承証条状常情織職制性政勢精製税責績接設舌絶銭祖素総造像増則測属率損退貸態団断築張提程適敵統銅導徳独任燃能破犯判版比肥非備俵評貧布婦富武復複仏編弁保墓報豊防貿暴務夢迷綿輸余預容略留領異遺域宇映延沿我灰拡革閣割株干巻看簡危机揮貴疑吸供胸郷勤筋系敬警劇激穴絹権憲源厳己呼誤后孝皇紅降鋼刻穀骨困砂座済裁策冊蚕至私姿視詞誌磁射捨尺若樹収宗就衆従縦縮熟純処署諸除将傷障城蒸針仁垂推寸盛聖誠宣専泉洗染善奏窓創装層操蔵臓存尊宅担探誕段暖値宙忠著庁頂潮賃痛展討党糖届難乳認納脳派拝背肺俳班晩否批秘腹奮並陛閉片補暮宝訪亡忘棒枚幕密盟模訳郵優幼欲翌乱卵覧裏律臨朗論'
      }
    ]
  },
  {
    name: '数字（1～10）',
    key: 'numbers_from_one_to_ten',
    selectOptions: [
      { order: 1, displayName: '1', value: '1' },
      { order: 2, displayName: '2', value: '2' },
      { order: 3, displayName: '3', value: '3' },
      { order: 4, displayName: '4', value: '4' },
      { order: 5, displayName: '5', value: '5' },
      { order: 6, displayName: '6', value: '6' },
      { order: 7, displayName: '7', value: '7' },
      { order: 8, displayName: '8', value: '8' },
      { order: 9, displayName: '9', value: '9' },
      { order: 10, displayName: '10', value: '10' }
    ]
  },
  {
    name: '数字（1～30）',
    key: 'numbers_from_one_to_thirty',
    selectOptions: [
      { order: 1, displayName: '1', value: '1' },
      { order: 2, displayName: '2', value: '2' },
      { order: 3, displayName: '3', value: '3' },
      { order: 4, displayName: '4', value: '4' },
      { order: 5, displayName: '5', value: '5' },
      { order: 6, displayName: '6', value: '6' },
      { order: 7, displayName: '7', value: '7' },
      { order: 8, displayName: '8', value: '8' },
      { order: 9, displayName: '9', value: '9' },
      { order: 10, displayName: '10', value: '10' },
      { order: 11, displayName: '11', value: '11' },
      { order: 12, displayName: '12', value: '12' },
      { order: 13, displayName: '13', value: '13' },
      { order: 14, displayName: '14', value: '14' },
      { order: 15, displayName: '15', value: '15' },
      { order: 16, displayName: '16', value: '16' },
      { order: 17, displayName: '17', value: '17' },
      { order: 18, displayName: '18', value: '18' },
      { order: 19, displayName: '19', value: '19' },
      { order: 20, displayName: '20', value: '20' },
      { order: 21, displayName: '21', value: '21' },
      { order: 22, displayName: '22', value: '22' },
      { order: 23, displayName: '23', value: '23' },
      { order: 24, displayName: '24', value: '24' },
      { order: 25, displayName: '25', value: '25' },
      { order: 26, displayName: '26', value: '26' },
      { order: 27, displayName: '27', value: '27' },
      { order: 28, displayName: '28', value: '28' },
      { order: 29, displayName: '29', value: '29' },
      { order: 30, displayName: '30', value: '30' }
    ]
  },
  {
    name: 'アルファベット（A～J）',
    key: 'alphabets_from_a_to_j',
    selectOptions: [
      { order: 1, displayName: 'A', value: 'A' },
      { order: 2, displayName: 'B', value: 'B' },
      { order: 3, displayName: 'C', value: 'C' },
      { order: 4, displayName: 'D', value: 'D' },
      { order: 5, displayName: 'E', value: 'E' },
      { order: 6, displayName: 'F', value: 'F' },
      { order: 7, displayName: 'G', value: 'G' },
      { order: 8, displayName: 'H', value: 'H' },
      { order: 9, displayName: 'I', value: 'I' },
      { order: 10, displayName: 'J', value: 'J' }
    ]
  },
  {
    name: 'アルファベット（全て）',
    key: 'alphabets_all',
    selectOptions: [
      { order: 1, displayName: 'A', value: 'A' },
      { order: 2, displayName: 'B', value: 'B' },
      { order: 3, displayName: 'C', value: 'C' },
      { order: 4, displayName: 'D', value: 'D' },
      { order: 5, displayName: 'E', value: 'E' },
      { order: 6, displayName: 'F', value: 'F' },
      { order: 7, displayName: 'G', value: 'G' },
      { order: 8, displayName: 'H', value: 'H' },
      { order: 9, displayName: 'I', value: 'I' },
      { order: 10, displayName: 'J', value: 'J' },
      { order: 11, displayName: 'K', value: 'K' },
      { order: 12, displayName: 'L', value: 'L' },
      { order: 13, displayName: 'M', value: 'M' },
      { order: 14, displayName: 'N', value: 'N' },
      { order: 15, displayName: 'O', value: 'O' },
      { order: 16, displayName: 'P', value: 'P' },
      { order: 17, displayName: 'Q', value: 'Q' },
      { order: 18, displayName: 'R', value: 'R' },
      { order: 19, displayName: 'S', value: 'S' },
      { order: 20, displayName: 'T', value: 'T' },
      { order: 21, displayName: 'U', value: 'U' },
      { order: 22, displayName: 'V', value: 'V' },
      { order: 23, displayName: 'W', value: 'W' },
      { order: 24, displayName: 'X', value: 'X' },
      { order: 25, displayName: 'Y', value: 'Y' },
      { order: 26, displayName: 'Z', value: 'Z' }
    ]
  }
]
export const _subject = ['数学', '英語', '国語', '理科', '社会', '算数', 'その他']

export const _responseOptions = [
  { order: 1, option: 'こんにちは', content: 'こんにちは' },
  { order: 2, option: 'おはよう', content: 'おはよう' },
  { order: 3, option: 'もっと教えてください', content: 'もっと教えてください' },
  { order: 4, option: '丁寧に説明してください', content: '丁寧に説明してください' },
  { order: 5, option: '英語で説明してください', content: '英語で説明してください' },
  { order: 6, option: '日本語で説明してください', content: '日本語で説明してください' }
]

export const _responseOptionsForInterview = [
  '最初からやり直したいです',
  '一つ前の質問をやり直してください',
  'ありがとうございました',
  'もっと難しい質問をしてください',
  'もっと簡単な質問をしてください',
  'よろしくお願いします',
  'アドバイスをしてください',
  'こんにちは',
  'ジャイアン口調で面接してください'
]

export const _prompt_type_choice_NANDE = ['ユーザー入力あり', 'ユーザー入力なし']
export const _prompt_type_choice_NON_NANDE = ['ユーザー入力なし']

export const _language_list_v1 = [
  { physicalName: 'ja', japaneseName: '日本語', shortenName: '日' },
  { physicalName: 'en-US', japaneseName: '英語', shortenName: '英' }
]
export const _language_list_v2 = [
  {
    physicalName: 'nova',
    languageCode: 'nova',
    type: 'openai-tts',
    japaneseName: '英語インプット/全言語(女)アウトプット',
    shortenName: '英語インプット/全言語(女)アウトプット',
    title: '【推奨】■入力:日本語　■出力:全言語（女）'
  },
  {
    physicalName: 'alloy',
    languageCode: 'alloy',
    type: 'openai-tts',
    japaneseName: '英語インプット/全言語(男)アウトプット',
    shortenName: '英語インプット/全言語(男)アウトプット',
    title: '【推奨】■入力:日本語　■出力:全言語（男）'
  },
  {
    physicalName: 'ja',
    languageCode: 'nova',
    type: 'openai-tts',
    japaneseName: '日本語インプット/全言語(女)アウトプット',
    shortenName: '日本語インプット/全言語(女)アウトプット',
    title: '【推奨】■入力:英語　■出力:全言語（女）'
  },
  {
    physicalName: 'ja',
    languageCode: 'alloy',
    type: 'openai-tts',
    japaneseName: '日本語インプット/全言語(男)アウトプット',
    shortenName: '日本語インプット/全言語(男)アウトプット',
    title: '【推奨】■入力:英語　■出力:全言語（男）'
  },
  {
    physicalName: 'ja',
    languageCode: 'ja-JP',
    type: 'ja-JP-Neural2-B',
    japaneseName: '日本語(女性)',
    shortenName: '日本語(女性)',
    title: '■入力:日本語　■出力:日本語（女）'
  },
  {
    physicalName: 'ja',
    languageCode: 'ja-JP',
    type: 'ja-JP-Neural2-C',
    japaneseName: '日本語(男性)',
    shortenName: '日本語(男性)',
    title: '■入力:日本語　■出力:日本語（男）'
  },
  {
    physicalName: 'en-US',
    languageCode: 'en-US',
    type: 'en-US-Neural2-H',
    japaneseName: '英語(女性)',
    shortenName: '英語(女性)',
    title: '■入力:英語　■出力:英語（女）'
  },
  {
    physicalName: 'en-US',
    languageCode: 'en-US',
    type: 'en-US-Neural2-I',
    japaneseName: '英語(男性)',
    shortenName: '英語(男性)',
    title: '■入力:英語　■出力:英語（男）'
  }
]

// 音声入力自動送信
export const _auto_sending = [
  { displayName: 'ON', value: true },
  { displayName: 'OFF', value: false }
]

// 音声の出力
export const _default_mute = [
  { displayName: 'ON', value: false },
  { displayName: 'OFF', value: true }
]

// 0~2 プルダウンではなく直接入力でもいいかも
export const _temperature = [
  0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2
]

// 0.25~4.0 プルダウンではなく直接入力でもいいかも
export const _speaking_rate = []

export const _question_type = [
  { displayName: 'テキスト', value: 'text' },
  { displayName: 'プルダウン', value: 'pulldown' },
  { displayName: '画像(試験運用中)', value: 'image' }
]

export const _abolished_gpt_input_cost = [
  { type: 'gpt-3.5-turbo-0125', cost: 0.001 },
  { type: 'gpt-4-0125-preview', cost: 0.01 }
]

export const _table_filter_periods = [
  { id: 0, displayName: '当日', value: 0, unit: 'day' },
  { id: 1, displayName: '昨日', value: 1, unit: 'day' },
  { id: 2, displayName: '過去一週間', value: 1, unit: 'lastWeek' },
  { id: 3, displayName: '全期間', value: 1, unit: 'all' },
  { id: 4, displayName: '今週', value: 1, unit: 'week' },
  { id: 5, displayName: '詳細検索', value: 0, unit: 'day' }
]

export const _logs_filter_periods = [
  { id: 0, displayName: '当日', value: 0, unit: 'day' },
  { id: 1, displayName: '昨日', value: 1, unit: 'day' },
  { id: 2, displayName: '過去一週間', value: 1, unit: 'lastWeek' },
  { id: 3, displayName: '全期間', value: 1, unit: 'all' }
]

export const _inserted_default_target_student_info = [
  { id: 'name', title: '生徒名', key: 'name' },
  { id: 'grade', title: '学年', key: 'grade' },
  { id: 'characteristic', title: '特徴', key: 'characteristic' }
]

export const listOfExcludedWords = [
  '.',
  '、',
  '。',
  '「',
  '」',
  '(',
  ')',
  '（',
  '）',
  '!',
  '！',
  '?',
  '？',
  '・',
  '〜',
  'ー',
  '…',
  '【',
  '】',
  '{',
  '}',
  '［',
  '］',
  '｛',
  '｝',
  '（',
  '）',
  '＜',
  '＞',
  '<',
  '>',
  '＆',
  '&',
  '＊',
  '*',
  '％',
  '%',
  '＃',
  '#',
  '＠',
  '@',
  '＄',
  '$',
  '＾',
  '^',
  '＋',
  '+',
  '＝',
  '=',
  '＼',
  '\\',
  '｜',
  '|',
  '；',
  ';',
  '：',
  ':',
  '“',
  '”',
  '‘',
  '’',
  'と',
  'が',
  'の',
  'に',
  'で',
  'は',
  'も',
  'から',
  'より',
  'な',
  'ね',
  'よ',
  'こと',
  'もの',
  'ため',
  'これ',
  'それ',
  'あれ',
  '1',
  'する',
  'いる',
  'れる'
]

export const tempFolder = {
  name: 'フォルダ1',
  type: 'self',
  createdAt: null,
  description: 'デフォルトフォルダです',
  uid: 'tempFolder',
  isTempFolder: true
}

export const defaultFolderDefinitions = [
  { name: '管理人', type: 'admin', createdAt: null, description: '管理人が作成したモードです', uid: 'adminFolder' },
  {
    name: '親スクール',
    type: 'parent',
    createdAt: null,
    description: '親スクールが作成したモードです',
    uid: 'parentFolder'
  },
  { ...tempFolder }
]
